import { FormType } from '../../../form-types';
import { ZaludStiTreatmentQuestionFieldAnswers } from './questions';

const stiTreatment: FormType<ZaludStiTreatmentQuestionFieldAnswers> = {
  name: 'STI Treatment Intake',
  questions: [
    {
      key: 'zalud_stiTreatment_recentPositiveTest',
      next: {
        condition: { 'zalud_stiTreatment_recentPositiveTest.yes': true },
        key: 'zalud_stiTreatment_upload',
        els: 'zalud_stiTreatment_negativeTestIneligible'
      }
    },
    'zalud_stiTreatment_upload',
    {
      key: 'zalud_stiTreatment_stisDiagnosed',
      next: {
        condition: { 'zalud_stiTreatment_stisDiagnosed.gonorrhea': true },
        key: 'zalud_stiTreatment_gonorrheaTestSite',
        els: 'zalud_stiTreatment_sexAssignedAtBirth'
      }
    },
    'zalud_stiTreatment_gonorrheaTestSite',
    {
      key: 'zalud_stiTreatment_sexAssignedAtBirth',
      next: {
        condition: {
          'zalud_stiTreatment_sexAssignedAtBirth.female': true
        },
        key: 'zalud_stiTreatment_symptomsFemale',
        els: 'zalud_stiTreatment_symptomsMale'
      }
    },
    {
      key: 'zalud_stiTreatment_symptomsFemale',
      next: {
        key: 'zalud_stiTreatment_sexualAssaultCare'
      }
    },
    'zalud_stiTreatment_symptomsMale',
    'zalud_stiTreatment_sexualAssaultCare',
    'zalud_stiTreatment_currentSymptoms',
    {
      key: 'zalud_stiTreatment_cephalosporinAllergy',
      next: {
        condition: { 'zalud_stiTreatment_cephalosporinAllergy.yes': true },
        key: 'zalud_stiTreatment_allergyReaction',
        els: 'zalud_stiTreatment_recentTreatment'
      }
    },
    {
      key: 'zalud_stiTreatment_allergyReaction',
      next: {
        switch: [
        {
          condition: { 'zalud_stiTreatment_allergyReaction.hives_swelling_wheezing': true },
          key: 'zalud_stiTreatment_ineligible'
        },
        {
          condition: { 'zalud_stiTreatment_allergyReaction.severe_blistering_hospitalization': true },
          key: 'zalud_stiTreatment_ineligible'
          }
        ],
        els: 'zalud_stiTreatment_recentTreatment'
      }
    },
    {
      key: 'zalud_stiTreatment_recentTreatment',
      next: {
        condition: { 'zalud_stiTreatment_recentTreatment.yes': true },
        key: 'zalud_stiTreatment_symptomResolution',
        els: 'zalud_stiTreatment_partnerNotification'
      }
    },
    {
      key: 'zalud_stiTreatment_symptomResolution',
      next: {
        condition: {
          'zalud_stiTreatment_symptomResolution.symptoms_persisted': true
        },
        key: 'zalud_stiTreatment_ineligible',
        els: 'zalud_stiTreatment_partnerNotification'
      }
    },
    'zalud_stiTreatment_partnerNotification',
    'zalud_stiTreatment_alcoholUse',
    'zalud_stiTreatment_additionalComments',
    {
      key: 'zalud_stiTreatment_consent',
      next: {
        condition: { 'zalud_stiTreatment_consent.proceed': true },
        key: 'zalud_stiTreatment_complete',
        els: 'zalud_stiTreatment_ineligible'
      }
    },
    'zalud_stiTreatment_complete',
    'zalud_stiTreatment_negativeTestIneligible',
    'zalud_stiTreatment_ineligible'
  ]
};

export default stiTreatment;
